import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar, MatDialog } from '@angular/material';
import { AppComponentClass } from '../../service/AppComponent.class';
import { Theme } from '../../service/AutoTheme';
import { MortgageService } from '../mortgage.service';
import { Option } from '../../model/model.class';
import { Edit, EditForm, PersonalInfoForm } from '../../../dialer/model/model.mortgage';
import { SipJsService } from '../../service/sipjsServices.class';
import { ISubscription } from "rxjs/Subscription";
import { PdfviewerComponent } from '../../pdfviewer/pdfviewer.component';
import { DatePipe } from '@angular/common';
// import { AlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditComponent extends AppComponentClass<any, any>  {

  private __data = new BehaviorSubject<Edit>(null);
  public solution = this.__data.asObservable();
  protected cellnostatus = new BehaviorSubject<boolean>(false);
  public cellnoview = this.cellnostatus.asObservable();
  protected homenostatus = new BehaviorSubject<boolean>(false);
  public homenoview = this.homenostatus.asObservable();
  protected worknostatus = new BehaviorSubject<boolean>(false);
  public worknoview = this.worknostatus.asObservable();
  protected emailstatus = new BehaviorSubject<boolean>(false);
  public emailview = this.emailstatus.asObservable();

  private __pdata = new BehaviorSubject<PersonalInfoForm>(null);
  public prssolution = this.__pdata.asObservable();
  currcampflag: string;
  crldata: any;
  crmlblmd: any;
  cdata1: PersonalInfoForm;
  bussinesshours: any;
  ismakecall: string;
  timezonelist: any;
  leadtimezone: any;
  findday: any;
  offset: any;
  getcurrtime: string;
  usertype: number;
  makeform: any;
  public assignd:any
  public assignblank:any=""
  lastcall: any;

  @Input() set editdata(v: Edit) {
    this.debug_log("Setting current data");
    this.__data.next(v);
  }

  @Input() set personaldata(v: PersonalInfoForm) {
    this.debug_log("Setting current data");
    this.__pdata.next(v);
  }

  @Input() busshour: any

  @Input() pdf: string;

  @Input() timezone: any

  public form: FormGroup;
  public formrecruit: FormGroup;
  public leadid = sessionStorage.getItem("leadID") || -1;
  public callerid = sessionStorage.getItem("callerid") || "None";
  public currscript = sessionStorage.getItem("currscript") || -1;
  public extaccount = sessionStorage.getItem("extaccount") || "None";
  public extuser = sessionStorage.getItem("extuser") || "NA";
  public emailtemp: Option[];
  public smstemp: Option[];
  public vdmsg: Option[];
  public event: any;
  public value: string;
  public viewValue: string;
  public __click2dial: boolean = false;
  public __hangup: boolean = false;
  public crmlbl: any;
  public issmsenable: boolean = false;
  public istimezone: boolean = false;
  public assign_date:any=""
  /* public ct_timezone:string; */

  private autodsubs: ISubscription;
  private autostopdsubs: ISubscription;
  private eventsubs: ISubscription;
  private callersubs: ISubscription;
  private personalnosubs: ISubscription;
  private senddtmfsipsubs: ISubscription;
  public jsondata = {};

  public getCamp = sessionStorage.getItem("currcampaign");
  public smspermission = sessionStorage.getItem("smsperm");
  public voicemailpermission = sessionStorage.getItem("voicemailperm");
  public check_SMTP =parseInt(sessionStorage.getItem('type'))==5 ?  parseInt(sessionStorage.getItem('available_smtp')) : 1
  constructor(public edata: MortgageService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar, protected theme: Theme, protected sipdata: SipJsService, public dialog: MatDialog,public datepipe : DatePipe) {
    super(edata, router, fb, msg);
    if (sessionStorage.getItem("calleridtype") == "DID API" && (sessionStorage.getItem("camp_status") != null) && sessionStorage.getItem("camp_status") != undefined) {
      this.issmsenable = true;
    }
    this.currcampflag = sessionStorage.getItem("currcampflag");
    this.usertype = parseInt(sessionStorage.getItem('type'));
  }

  ngOnInit() {
     this.sipdata.lastcalldata.subscribe(ress=>{
      if (ress != null && ress != undefined)
        this.lastcall = sessionStorage.getItem("lastcall");
    });

    if (this.currcampflag == '0') {
      console.log("date000");
      let crmlbldata = JSON.parse(sessionStorage.getItem("crmlabel"));
      let crmlbl = JSON.parse(crmlbldata[0].crm_mgt);
      this.crldata = crmlbl[0].fields;
      console.log(" this.crldata", this.crldata);
    }
    else {

      let crmlbldata = JSON.parse(sessionStorage.getItem("crmlabel"));
      this.crmlbl = JSON.parse(crmlbldata[0].crm_mgt);
      console.log(this.crmlbl)
      this.crldata = this.crmlbl[0].fields;

      this.crmlblmd = JSON.parse(crmlbldata[0].crm_mgt);
      let shift = this.crmlblmd.shift();

      this.crmlblmd.forEach(element => {
        console.log("elemet value:::", element.fields)
        element.fields.forEach(ele => {
          console.log("ele:", ele)
          if (ele.fields == 'assign_date') {
            this.assign_date = ele
          }
        })
      })
      console.log("assign_date::", this.assign_date)
    }

    console.log(" this.crldata 1", this.crldata);
    for (let i = 0; i < this.crldata.length; i++) {
      if (this.crldata.label != '') {
             this.jsondata = Object.assign({ [this.crldata[i].fields]: this.crldata[i].label, [this.crldata[i].fields + "st"]: true }, this.jsondata);
      }
    }

    this.crmlbl = this.jsondata

    if (this.currcampflag == '1') {
      this.prssolution.subscribe(res => {
        console.log("kirti:",res)
        if (res == null) {

          this.cdata1 = new PersonalInfoForm(null);
          this.formrecruit = this.cdata1.makeform(this.fb);
        }
        else {
          this.cdata1 = new PersonalInfoForm(res);

          this.formrecruit = this.cdata1.makeform(this.fb);
          this.assignd=this.cdata1.assign_date
        }
      })
    }

    this.solution.subscribe(res => {
      this.lastcall = sessionStorage.getItem("lastcall");
      console.log(this.lastcall)
      
      if (res == null) {
        
        this.cdata = new EditForm(null);
        this.form = this.cdata.makeform(this.fb);
      }
      else {
        this.theme.ChangeColor('green');
        this.cdata = new EditForm(res);
        this.leadtimezone = this.cdata.timezone
        this.form = this.cdata.makeform(this.fb);
        this.leadid = sessionStorage.getItem("leadID");
        sessionStorage.setItem("edit", JSON.stringify(this.cdata));
        if (this.cdata.cell_phone)
        this.cellnostatus.next(true);
        if (this.cdata.phone)
        this.homenostatus.next(true);
        if (this.cdata.work_phone)
          this.worknostatus.next(true);

          if (this.cdata.email)
          this.emailstatus.next(true);
          
          if (this.cdata.cell_phone != null)
          sessionStorage.setItem('current_number', this.cdata.cell_phone);
          else {
            if (this.cdata.phone != null)
            sessionStorage.setItem('current_number', this.cdata.phone);
            else {
              if (this.cdata.work_phone != null)
              sessionStorage.setItem('current_number', this.cdata.work_phone);
            }
            
          }


          // sessionStorage.setItem("totalcallattempts", (0).toString());
        }
        
        // this.timezonelist.forEach((e:any)=>{if(this.cdata.timezone == e.abbr){let UTCtime=e.timezone
        //   console.log(UTCtime);
        //   let nowtime=new Date().toLocaleString("en-US", {timeZone: UTCtime})
        //   this.cdata.current_time =nowtime}})
        //   console.log(this.cdata);
        //   sessionStorage.setItem("edit", JSON.stringify(this.cdata));
       });

      
      /*  this.theme.clienttimezone.subscribe(res =>{
        if(res != null)
        {
          console.log("TTTTTTTTTTTTTAAAAAAAAAAA::"+res);
          this.ct_timezone = res.timezone;
          this.istimezone=true;
        }
      });    */
      
      this.theme.emailsolution.subscribe(res => {
        console.log("email option");
        console.log(res);
        if (res && res != null && res.length > 0)
        this.emailtemp = res;
        else
        this.emailtemp = [{ "label": "No option", "value": 0 }]
      });
      
      this.theme.smsolution.subscribe(res => {
        console.log("sms option");
        console.log(res);
        if (res && res != null && res.length > 0)
        this.smstemp = res;
        else
        this.smstemp = [{ "label": "No option", "value": 0 }]
      });
      
      /* this.theme.vdsolution.subscribe(res => {
        console.log("vd option");
        console.log(res);
        if (res && res != null && res.length > 0)
        this.vdmsg = res;
        else
        this.vdmsg = [{ "label": "No option", "value": 0 }]
      });
      */
     this.eventsubs = this.theme.event.subscribe(res => {
       console.log("Current changed dial type is : " + res);
       console.log("cdata",this.cdata);
       
       if (res == 0) {
         this.__click2dial = true;
         this.__hangup = false;
        }
        else {
          this.__click2dial = false;
          // this.__hangup = false;
          this.__hangup = true; //for autodialer disaapear call button
        }
      });
      
      /*  this.autodsubs = this.theme.startautodial.subscribe(res => {
        if (res != undefined) {
          let prefdata = JSON.parse(sessionStorage.getItem("preferences"));
          let attampts = parseInt(sessionStorage.getItem("callattampts"));
          let type = parseInt(sessionStorage.getItem("phonetype"));
          console.log("Current phone type ::" + type);
          console.log("Current phone Attampts ::" + attampts);
          console.log("Current Autodial are :: " + sessionStorage.getItem("isautodial"));
          
          if (parseInt(sessionStorage.getItem("isautodial")) == 1) {
            switch (type) {
              case 1: {
                if (prefdata.cellphone > attampts) {
                  if (this.cdata.cell_phone != "" && this.cdata.cell_phone != null && this.cdata.cell_phone != "null" && this.cdata.cell_phone != undefined) {
                    if (parseInt(sessionStorage.getItem("callattampts")) > 1) {
                      setTimeout(() => { this.makeCall(1); }, 2000);
                    }
                    else
                    this.makeCall(1);
                    sessionStorage.setItem("callattampts", (attampts + 1).toString());
                  }
                  else {
                    sessionStorage.setItem("phonetype", (type + 1).toString());
                    sessionStorage.setItem("callattampts", (0).toString());
                    this.theme.StartAutodial(2);
                  }
                }
                else {
                  sessionStorage.setItem("phonetype", (type + 1).toString());
                  console.log("current type::" + (type + 1).toString()),
                  sessionStorage.setItem("callattampts", (0).toString());
                  this.theme.StartAutodial(2);
                }
                break;
              }
              case 2: {
                if (prefdata.homephone > attampts) {
                  if (this.cdata.phone != "" && this.cdata.phone != null && this.cdata.phone != "null" && this.cdata.phone != undefined) {
                    if (parseInt(sessionStorage.getItem("callattampts")) > 1) {
                      setTimeout(() => { this.makeCall(2); }, 2000);
                    }
                    else
                    this.makeCall(2);
                    sessionStorage.setItem("callattampts", (attampts + 1).toString());
                  }
                  else {
                    sessionStorage.setItem("phonetype", (type + 1).toString());
                    sessionStorage.setItem("callattampts", (0).toString());
                    this.theme.StartAutodial(3);
                    
                }
              }
              else {
                sessionStorage.setItem("phonetype", (type + 1).toString());
                sessionStorage.setItem("callattampts", (0).toString());
                this.theme.StartAutodial(3);
              }
              break;
            }
            case 3: {
              if (prefdata.workphone > attampts) {
                if (this.cdata.work_phone != "" && this.cdata.work_phone != null && this.cdata.work_phone != "null" && this.cdata.work_phone != undefined) {
                  if (parseInt(sessionStorage.getItem("callattampts")) > 1) {
                    setTimeout(() => { this.makeCall(3); }, 2000);
                  }
                  else
                  this.makeCall(3);
                  sessionStorage.setItem("callattampts", (attampts + 1).toString());
                }
                else {
                  sessionStorage.setItem("phonetype", (0).toString());
                  //this.theme.ChangeAutodial(1);
                }
              }
              else {
                sessionStorage.setItem("phonetype", (0).toString());
                sessionStorage.setItem("callattampts", (0).toString());
                sessionStorage.setItem("totalcallattempts", (0).toString());
              }
              break;
            }
          }
          
          if (type > 3) {
            sessionStorage.setItem("phonetype", (0).toString());
            sessionStorage.setItem("callattampts", (0).toString());
            sessionStorage.setItem("totalcallattempts", (0).toString());
          }
        }
      }
    }); */
    
    
    // Changed Dialing sequence.
    this.autodsubs = this.theme.startautodial.subscribe(res =>{
      if(res !=undefined)
      {
        console.log(res)
        /* let prefdata = JSON.parse(sessionStorage.getItem("preferences")); */
        let attampts = parseInt(sessionStorage.getItem("callattampts"));
        let type = parseInt(sessionStorage.getItem("phonetype"));  
        let autoattp = parseInt(sessionStorage.getItem("autoattempts"));     
        console.log("Current phone type ::"+type);
        console.log("Current phone Attampts ::"+attampts);
        console.log("Current Autodial are :: "+sessionStorage.getItem("isautodial"));
        
        if(parseInt(sessionStorage.getItem("isautodial"))==1)
        {  
          if(attampts < 3 && autoattp<2){     
            switch (type)
            {
              case 1: {
                  if(this.cdata.cell_phone !="" && this.cdata.cell_phone != null && this.cdata.cell_phone != "null" && this.cdata.cell_phone != undefined)
                  {
                    if(parseInt(sessionStorage.getItem("callattampts")) > 1)
                    {
                      setTimeout( () => { this.makeCall(1); }, 2000);
                    }
                    else
                    this.makeCall(1);
                    sessionStorage.setItem("phonetype", (type+1).toString());
                    sessionStorage.setItem("callattampts", (attampts+1).toString());
                    sessionStorage.setItem("autoattempts", (autoattp+1).toString());
                  }
                  else
                  {
                    sessionStorage.setItem("phonetype", (type+1).toString());
                    //sessionStorage.setItem("callattampts", (0).toString());
                    this.theme.StartAutodial(2);
                  }                  
                  break;
                }
                case 2: {
                  if(this.cdata.phone !="" && this.cdata.phone != null && this.cdata.phone != "null" && this.cdata.phone != undefined)
                  {
                    if(parseInt(sessionStorage.getItem("callattampts")) > 1)
                    {
                      setTimeout( () => { this.makeCall(2); }, 2000);
                    }
                    else
                    this.makeCall(2);
                    sessionStorage.setItem("phonetype", (type+1).toString());
                    sessionStorage.setItem("callattampts", (attampts+1).toString());
                    sessionStorage.setItem("autoattempts", (autoattp+1).toString());
                  }
                  else
                  {
                    sessionStorage.setItem("phonetype", (type+1).toString());
                    //sessionStorage.setItem("callattampts", (0).toString());
                    this.theme.StartAutodial(3);                    
                  }                  
                  break;
                }
                case 3: {                
                  if(this.cdata.work_phone !="" && this.cdata.work_phone != null && this.cdata.work_phone != "null" && this.cdata.work_phone != undefined)
                  {
                    if(parseInt(sessionStorage.getItem("callattampts")) > 1)
                    {
                      setTimeout( () => { this.makeCall(3); }, 2000);
                    }
                    else
                    this.makeCall(3);
                    sessionStorage.setItem("phonetype", (1).toString());
                    sessionStorage.setItem("callattampts", (attampts+1).toString());
                    sessionStorage.setItem("autoattempts", (autoattp+1).toString());
                  }
                  else
                  {
                    sessionStorage.setItem("phonetype", (1).toString()); 
                    this.theme.StartAutodial(1);
                    //sessionStorage.setItem("callattampts", (0).toString());                 
                  }                
                  break;
                }
              }
            }
            
            if(type>3)
            {
              sessionStorage.setItem("phonetype", (0).toString());
              sessionStorage.setItem("callattampts", (0).toString());
            }
          }
        }
      });
      
      this.autostopdsubs = this.theme.stopautodial.subscribe(res => {
        if (res == 1) {
          this.Hangup();
        }
      });
      
      this.callersubs = this.theme.callerid.subscribe(res => {
        if (res != null && res != undefined) {
          if (res.num_type == "DID API")
            this.issmsenable = true;
        else
          this.issmsenable = false;
      }
    });
    
    this.theme.unregistersip.subscribe(res => {
      if (res) {
        this.sipdata.UnregisterUA();
      }
    });
    
    /* Dial Personal Number */
    this.personalnosubs = this.theme.personalnumber.subscribe(res => {
      if (res != null) {
        sessionStorage.setItem('current_number', res);
        sessionStorage.setItem('number_type', 'mdi-cellphone');
        this.OriginateCall();
      }
    });
    
    /* Send DTMf */
    this.senddtmfsipsubs = this.theme.senddtmfsip.subscribe(res => {
      console.log("DTMF on edit", res);
      if (res != null) {
        this.sipdata.SendDTMF(res);
      }
    });
    
    this.busshour.subscribe(res => {
      console.log("busse", res)
      this.bussinesshours = res;
    })
    
    this.timezone.subscribe(res => {
      this.timezonelist = res;
    })
    this.solution.subscribe((res)=>{

      this.setCurrentTime();
    })

  }
  
  get f() { return this.makeform.controls; }
  
  
  //acceppt only numeric value
  ValidateIn(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }

  clickEmail(value: number) {
    console.log(this.check_SMTP);
    if (value && value > 0) {
      // if(this.check_SMTP){
        console.log(value);
        let sdata = { id_lead: sessionStorage.getItem("leadID"), id_template: value, to_email: this.cdata.email };
        this.sendemail(sdata)
      // }else{
        // const dialogRef = this.dialog.open(AlertComponent,{
        //   width: '700px',
        //   data: { name: "custom", type: 30 }
        // });
      // }

    }
    else {
      this.openSnackBar("No Email Option is available", '');
    }
  }

  clickSms(value: number, type: any) {
    console.log("this.cdataa", this.cdata.cell_phone, type)

    if (value && value > 0) {
      console.log(value);
      this.leadid = sessionStorage.getItem("leadID");
      /* this.callerid=sessionStorage.getItem("callerid"); */
      let finalcaller = sessionStorage.getItem("callerid");
      let to_number: string;
      switch (type) {
        case '0':
        case 0:
          {

            if (this.cdata.cell_phone.length > 10)

              to_number = '+' + this.cdata.cell_phone;

            else

              to_number = '+1' + this.cdata.cell_phone;

            sessionStorage.setItem('current_number', this.cdata.cell_phone);
            sessionStorage.setItem('number_type', 'mdi-cellphone');
            break;
          }
        case '1':
        case 1:
          {
          if (this.cdata.phone.length > 10)
            to_number = '+' + this.cdata.phone;
          else
            to_number = '+1' + this.cdata.phone;
          sessionStorage.setItem('current_number', this.cdata.phone);
          sessionStorage.setItem('number_type', 'mdi-home');
          break;
        }
        case '2':
        case 2:
          {
          if (this.cdata.work_phone.length > 10)
            to_number = '+' + this.cdata.work_phone;
          else
            to_number = '+1' + this.cdata.work_phone;
          sessionStorage.setItem('current_number', this.cdata.work_phone);
          sessionStorage.setItem('number_type', 'mdi-worker');
        }
      }
      console.log("to_number", to_number)

      if (finalcaller.length > 11)
        finalcaller = sessionStorage.getItem("callerid");
      else
        finalcaller = '+' + sessionStorage.getItem("callerid");

      let sdata = { id_lead: this.leadid, id_template: value, to_number: to_number, from_number: finalcaller ,smstype:type };
      if (parseInt(sessionStorage.getItem("sms")) > 0)
        this.sendSms(sdata)
      else
        alert("You Don't have Sufficient SMS Pack to send SMS. Please Buy SMS Package to send SMS");

    }
    else {
      this.openSnackBar("No SMS Option is available", '');
    }
  }

  sendSms(sdata: any) {
    console.log("recruting and insurance dialer sms send", sdata)

    let is_permision = this.bussinesshours.find((item: any) => {
      console.log(item)
      if (item.type == 2)
        return true
      else
        return false
    })
    var today = new Date();
    var currday = today.getDay()
    this.offset = this.getOffset();
    if (this.offset != undefined || this.offset != null) {
      let currtime = this.calcTime(this.offset)
      if (is_permision != undefined || is_permision != null) {
        this.bussinesshours.forEach(element => {
          console.log(element.type)
          if (element.type == 2) {
            let days = element.day.split(',')
            var findday = days.find(function (element: any) {
              return element == currday;
            });
            if (findday) {
              console.log(currtime + ">=" + element.start + " &&" + currtime + "<=" + element.end)
              if (currtime >= element.start && currtime <= element.end) {
                this.theme.changeSms(JSON.stringify(sdata));
              }
              else {

                alert("You are attempting to text a client outside of the allowable business hours from " +  this.time_transform(element.start)+ " to " +  this.time_transform(element.end)+ " (" + this.leadtimezone + ") in the client's local time zone. Please try again during allowable business hours.")

                // alert("You are attempting to send a SMS to a customer after the allowable business hours of " + element.start + " to " + element.end + " (" + this.leadtimezone + ").  Please try again tomorrow.")
                this.__hangup = false;
                this.__click2dial = true;
              }
            }
            else {
              alert("You are not allowed to send a SMS today. Contact to admin!")
              this.__hangup = false;
              this.__click2dial = true;
            }
          }
        });
      } else {
        alert("Business setting are not set to send sms. Contact to admin!")
      }
    } else {
      alert("Client Timezone not Set! Please Set a Client Timezone")
    }
  }

/*   clickVoiceDrop(value: number, type: string) {
    if (value && value > 0) {
      console.log("working: " + value);
      this.leadid = sessionStorage.getItem("leadID");
      let to_number;
      switch (type) {
        case '1': {
          sessionStorage.setItem('current_number', this.cdata.cell_phone);
          sessionStorage.setItem('number_type', 'mdi-cellphone');
          if (this.cdata.cell_phone.length > 10)
            to_number = this.cdata.cell_phone;
          else
            to_number = '1' + this.cdata.cell_phone;
          break;
        }
        case '2': {
          sessionStorage.setItem('current_number', this.cdata.phone);
          sessionStorage.setItem('number_type', 'mdi-home');
          if (this.cdata.phone.length > 10)
            to_number = this.cdata.phone;
          else
            to_number = '1' + this.cdata.phone;
          break;
        }
        case '3': {
          sessionStorage.setItem('current_number', this.cdata.work_phone);
          sessionStorage.setItem('number_type', 'mdi-worker');
          if (this.cdata.work_phone.length > 10)
            to_number = this.cdata.work_phone;
          else
            to_number = '1' + this.cdata.work_phone;
        }
      }
      let sdata = { id_lead: this.leadid, id_message: 0, audio: value, to_number: to_number, from_number: sessionStorage.getItem("callerid") };

      if (parseInt(sessionStorage.getItem("voicemail")) > 0)
        this.voicemaildrop(sdata)
      else
        alert("You Don't have Sufficient Voicemail Pack to send Ringless Voicemail. Please Buy Voicemail Package to send Ringless Voicemail")

    }
    else {
      this.openSnackBar("No VoiceDrop Option is available", 'Clear');
    }
  } */

/*   voicemaildrop(sdata: any) {
    let is_permision = this.bussinesshours.find((item: any) => {
      console.log(item)
      if (item.type == 4)
        return true
      else
        return false
    })
    var today = new Date();
    var currday = today.getDay()
    this.offset = this.getOffset();
    if (this.offset != undefined || this.offset != null) {
      let currtime = this.calcTime(this.offset)
      if (is_permision != undefined || is_permision != null) {
        this.bussinesshours.forEach(element => {
          console.log(element.type)
          if (element.type == 4) {
            let days = element.day.split(',')
            var findday = days.find(function (element: any) {
              return element == currday;
            });
            if (findday) {
              console.log(currtime + ">=" + element.start + " &&" + currtime + "<=" + element.end)
              if (currtime >= element.start && currtime <= element.end) {
                this.theme.SaveVdSms(JSON.stringify(sdata));
              }
              else {
                alert("You are attempting to send a voicemail to a customer after the allowable business hours of " + element.start + " to " + element.end + " (" + this.leadtimezone + ").  Please try again tomorrow.")
                this.__hangup = false;
                this.__click2dial = true;
              }
            }
            else {
              alert("You are not allowed to drop voicemail today. Contact to admin!")
              this.__hangup = false;
              this.__click2dial = true;
            }
          }
        });
      } else {
        alert("Business setting are not set to send voice mail. Contact to admin!")
      }
    } else {
      alert("Client Timezone not Set! Please Set a Client Timezone")
    }
  } */

  sendemail(sdata: any) {
    let is_permision = this.bussinesshours.find((item: any) => {
      console.log(item)
      if (item.type == 3)
        return true
      else
        return false
    })
    var today = new Date();
    var currday = today.getDay()
    this.offset = this.getOffset();
    if (this.offset != undefined || this.offset != null) {
      let currtime = this.calcTime(this.offset)
      if (is_permision != undefined || is_permision != null) {
        this.bussinesshours.forEach(element => {
          console.log(element.type)
          if (element.type == 3) {
            let days = element.day.split(',')
            var findday = days.find(function (element: any) {
              return element == currday;
            });
            if (findday) {
              console.log(currtime + ">=" + element.start + " &&" + currtime + "<=" + element.end)
              if (currtime >= element.start && currtime <= element.end) {
                this.theme.SaveEmail(JSON.stringify(sdata));
              }
              else {
                //alert("You are attempting to send a email to a customer after the allowable business hours of " + element.start + " to " + element.end + " (" + this.leadtimezone + ").  Please try again tomorrow.")
                alert("You are attempting to email a client outside of the allowable business hours from " + this.time_transform(element.start) + " to " +  this.time_transform(element.end) + " (" + this.leadtimezone + ") in the client's local time zone. Please try again during allowable business hours.")
                this.__hangup = false;
                this.__click2dial = true;
              }
            }
            else {
              alert("You are not allowed to send a Email today. Contact to admin!")
              this.__hangup = false;
              this.__click2dial = true;
            }
          }
        });
      } else {
        alert("Business setting are not set to send email. Contact to admin!")
      }
    } else {
      alert("Client Timezone not Set! Please Set a Client Timezone")
    }
  }

  onSubmit() {
    if (this.cdata.saveForm(this.form))
      super.onSubmit();
  }

  /*  ClickToCall(type:number)
   {
     this.__hangup=true;
     this.__click2dial=false;
     this.makeCall(type);
   } */

/*   makeCall(type: number) {
    console.log("Make Call Has Been Initiated ::",this.cdata.cell_phone);
    this.leadid = sessionStorage.getItem("leadID");
    let totalattempts = parseInt(sessionStorage.getItem("totalcallattempts"));
    sessionStorage.setItem("totalcallattempts", (totalattempts + 1).toString());
    if((totalattempts+1) <=3){
      this.theme.SetLastCall(totalattempts+1);
      if(parseInt(sessionStorage.getItem("isautodial"))==1)
      {
        this.__click2dial=false;
        this.__hangup=false;
      }
      else
      {
        this.__hangup=true;
        this.__click2dial=false;
      }
    switch (type) {
      case 1: {
        console.log("Current Number" + this.cdata.cell_phone);

        if (this.cdata.cell_phone != "" && this.cdata.cell_phone != null && this.cdata.cell_phone != "null" && this.cdata.cell_phone != undefined) {
          sessionStorage.setItem('current_number', this.cdata.cell_phone);
          this.OriginateCall(parseInt(this.cdata.cell_phone));
        }
        sessionStorage.setItem('number_type', 'mdi-cellphone');
        break;
      }
      case 2: {
        console.log("Current Number" + this.cdata.phone);
        if (this.cdata.phone != "" && this.cdata.phone != null && this.cdata.phone != "null" && this.cdata.phone != undefined) {
          sessionStorage.setItem('current_number', this.cdata.phone);
          this.OriginateCall(parseInt(this.cdata.phone));
        }
        sessionStorage.setItem('number_type', 'mdi-home');
        break;
      }
      case 3: {
        console.log("Current Number" + this.cdata.work_phone);
        if (this.cdata.work_phone != "" && this.cdata.work_phone != null && this.cdata.work_phone != "null" && this.cdata.work_phone != undefined) {
          sessionStorage.setItem('current_number', this.cdata.work_phone);
          this.OriginateCall(parseInt(this.cdata.work_phone));
        }
        sessionStorage.setItem('number_type', 'mdi-worker');
        break;
      }
    }
  } else
  {
    alert("A contact can be dial max 3 times in 24 hour. So you are able to dial after 24 hour.");
  }
  } */

  OriginateCall()
  {    
    if(parseInt(sessionStorage.getItem("minutes")) < 1 && parseInt(sessionStorage.getItem("buy_minutes")) < 1)
    {
      alert("You Don't have Sufficient Minutes for Making Outbound call. Please Buy Minutes to MakeCall")
    }
    else
    {
      this.sipdata.MakeOutboundCall();
      let totalattempts = parseInt(sessionStorage.getItem("totalcallattempts"));
      sessionStorage.setItem("totalcallattempts", (totalattempts+1).toString());
      this.theme.SetLastCall(totalattempts+1);
    }      
   
  }

  makeCall(type:number){
    /* Check business hour */
    var today = new Date();
    
    var currday = today.getDay()
    this.offset = this.getOffset();
    console.log('Offset lists ',this.offset);
    if (this.offset != undefined || this.offset != null) {
      let currtime = this.calcTime(this.offset)
      this.bussinesshours.forEach((element:any) => {
        if (element.type == 1) {
          let days = element.day.split(',')
          var findday = days.find(function (element: any) {
            return element == currday;
          });
          if (findday) {
            console.log(currtime + ">=" + element.start + " &&" + currtime + "<=" + element.end)
            if (currtime >= element.start && currtime <= element.end) {

              /** 
               * Start Make Call               * 
               */
              this.leadid=sessionStorage.getItem("leadID");
              let totalattempts = parseInt(sessionStorage.getItem("totalcallattempts"));
              //sessionStorage.setItem("totalcallattempts", (totalattempts+1).toString());    
              if((totalattempts+1) <=3){
                //this.theme.SetLastCall(totalattempts+1);
                if(parseInt(sessionStorage.getItem("isautodial"))==1)
                {
                  this.__click2dial=false;
                  this.__hangup=true;
                }
                else
                {
                  this.__hangup=true;
                  this.__click2dial=false;
                }
                
                switch (type)
                {
                  case 1: {
                    console.log("Current Number"+this.cdata.cell_phone);       
                    
                    if(this.cdata.cell_phone !="" && this.cdata.cell_phone != null && this.cdata.cell_phone != "null" && this.cdata.cell_phone != undefined)
                    {
                      sessionStorage.setItem('current_number', this.cdata.cell_phone);
                      this.OriginateCall();
                    }       
                    sessionStorage.setItem('number_type', 'mdi-cellphone');
                    break;
                  }
                  case 2: {
                    console.log("Current Number"+this.cdata.phone);        
                    if(this.cdata.phone !="" && this.cdata.phone != null && this.cdata.phone != "null" && this.cdata.phone != undefined)
                    {
                      sessionStorage.setItem('current_number', this.cdata.phone);
                      this.OriginateCall();
                    }        
                    sessionStorage.setItem('number_type', 'mdi-home');
                    break;
                  }
                  case 3: {
                    console.log("Current Number"+this.cdata.work_phone);        
                    if(this.cdata.work_phone !="" && this.cdata.work_phone != null && this.cdata.work_phone != "null" && this.cdata.work_phone != undefined)
                    {
                      sessionStorage.setItem('current_number', this.cdata.work_phone);
                      this.OriginateCall(); 
                    }       
                    sessionStorage.setItem('number_type', 'mdi-worker');       
                    break;
                  }     
                }
              }
              else
              {
                alert("A client can be called no more than 3 times in a 24-hour period. Please try calling this client again after 24 hours.");
              }
              /**
               * Stop Make Call
               */

            }
            else {
              alert("You are attempting to call a client outside of the allowable business hours from " +  this.time_transform(element.start) + " to " +  this.time_transform(element.end) + " (" + this.leadtimezone + ") in the client's local time zone. Please try again during allowable business hours.")
              this.__hangup = false;
              this.__click2dial = true;
            }
          }
          else {
            alert("You are not allowed to make a call today. Contact to admin!")
            this.__hangup = false;
            this.__click2dial = true;
          }
        }
      });
    }
    else {
      alert("Client Timezone not Set! Please Set a Client Timezone")
      this.__hangup = false;
      this.__click2dial = true;
    } 
  }

  calcTime(offset: any) {
    var d = new Date();
    console.log('timezone our djflasdf:::',d.getTimezoneOffset());
    var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    var nd = new Date(new Date(utc + (3600000 * offset)));    
    return nd.toLocaleTimeString('en-GB', { hour12: false, hour: '2-digit', minute: '2-digit' })
  }

  // calcTime1(offset: any) {
  //   var d = new Date();
  //   var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
  //   var nd = new Date(new Date(utc + (3600000 * offset)));
  //   return nd.toLocaleTimeString('en-GB')
  // }

/*   OriginateCall(dialnumber: number) {
    if (parseInt(sessionStorage.getItem("minutes")) < 1 && parseInt(sessionStorage.getItem("buy_minutes")) < 1) {
      let alrtmsg: string;
      if (this.usertype == 5)
        alrtmsg = "Please Contact to Manager for Buy Minutes";
      else
        alrtmsg = "Please Buy Minutes to MakeCall";

      alert("You Don't have Sufficient Minutes for Making Outbound call." + alrtmsg + " ");
    }
    else {
      let is_permision = this.bussinesshours.find((item: any) => {
        console.log(item)
        if (item.type == 1)
          return true
        else
          return false
      });
      var today = new Date();
      var currday = today.getDay()
      this.offset = this.getOffset();
      console.log(this.offset);
      if (this.offset != undefined || this.offset != null) {
        let currtime = this.calcTime(this.offset)
        // let currtime=this.getcurrtime;
        if (is_permision != undefined || is_permision != null) {
          this.bussinesshours.forEach(element => {
            if (element.type == 1) {
              let days = element.day.split(',')
              var findday = days.find(function (element: any) {
                return element == currday;
              });
              if (findday) {
                console.log(currtime + ">=" + element.start + " &&" + currtime + "<=" + element.end)
                if (currtime >= element.start && currtime <= element.end) {
                  this.sipdata.MakeOutboundCall();
                }
                else {
                  alert("You are attempting to call a customer after the allowable business hours of " + element.start + " to " + element.end + " (" + this.leadtimezone + ").  Please try again tomorrow.")
                  this.__hangup = false;
                  this.__click2dial = true;
                }
              }
              else {
                alert("You are not allowed to make a call today. Contact to admin!")
                this.__hangup = false;
                this.__click2dial = true;
              }
            }
          });
        } else {
          alert("Business setting are not set to make a call. Contact to admin!");
          this.__hangup = false;
          this.__click2dial = true;
        }
      }
      else {
        alert("Client Timezone not Set! Please Set a Client Timezone")
        this.__hangup = false;
        this.__click2dial = true;
      }
    }
  } */

  /*  OriginateCall(dialnumber:number)
   {
     if(parseInt(sessionStorage.getItem("minutes")) < 1 && parseInt(sessionStorage.getItem("buy_minutes")) < 1)
       alert("You Don't have Sufficient Minutes for Making Outbound call. Please Buy Minutes to MakeCall")
     else
     {
       if(sessionStorage.getItem('callerid').length==11)
         if(sessionStorage.getItem('current_number').length==11)
           this.sipdata.MakeOutboundCall();
         else
           alert("Invalid Number. Please Check number.");
       else
       {
         let allcaller = JSON.parse(sessionStorage.getItem("allcallerid"));
         if(allcaller != null && allcaller != undefined)
         {
           sessionStorage.setItem('callerid', allcaller[0].number);
           if(sessionStorage.getItem('current_number').length==11)
             this.sipdata.MakeOutboundCall();
           else
             alert("Invalid Number. Please Check number.");
         }
         else
           alert("Invalid Caller ID. Please change Caller ID.");
       }

     }

   } */

  Hangup() {
    this.__hangup = false;
    this.__click2dial = true;
    console.log("Hangup Called Insurance::: ====>");
    this.sipdata.HangupCall();    
  }

  warning() {
    if (this.cdata.first_name != this.form.get("first_name").value)
      this.cdata.first_name = this.form.get("first_name").value;
    if (this.cdata.last_name != this.form.get("last_name").value)
      this.cdata.last_name = this.form.get("last_name").value;
    // if(this.cdata.spouse_full_name != this.form.get("spouse_full_name").value)
    //   this.cdata.spouse_full_name = this.form.get("spouse_full_name").value;
    if (this.cdata.street_address_1 != this.form.get("street_address_1").value)
      this.cdata.street_address_1 = this.form.get("street_address_1").value;
    if (this.cdata.city != this.form.get("city").value)
      this.cdata.city = this.form.get("city").value;
    if (this.cdata.state != this.form.get("state").value)
      this.cdata.state = this.form.get("state").value;
    if (this.cdata.zip != this.form.get("zip").value)
      this.cdata.zip = this.form.get("zip").value;
    if (this.cdata.county != this.form.get("county").value)
      this.cdata.county = this.form.get("county").value;
    if (this.cdata.email != this.form.get("email").value)
      this.cdata.email = this.form.get("email").value;
    if (this.cdata.timezone != this.form.get("timezone").value)
      this.cdata.timezone = this.form.get("timezone").value;

      this.cdata.fullname = this.form.get("first_name").value.toUpperCase()+" " +this.form.get("last_name").value.toUpperCase()

    /* Recruiting personal data */
    if (this.currcampflag == '1') {
      console.log("data:::",this.assignd)
      if(this.assignd!="")
      {
        this.cdata1.assign_date=this.assignd
        console.log("cdata for assign",this.cdata1.assign_date)
      }

      if (this.cdata1.birth_date != this.formrecruit.get("birth_date").value)
        this.cdata1.birth_date = this.formrecruit.get("birth_date").value;
      if (this.cdata1.spouse_birth_date != this.formrecruit.get("spouse_birth_date").value)
        this.cdata1.spouse_birth_date = this.formrecruit.get("spouse_birth_date").value;
      if (this.cdata1.age != this.formrecruit.get("age").value)
        this.cdata1.age = this.formrecruit.get("age").value;
      if (this.cdata1.spouse_age != this.formrecruit.get("spouse_age").value)
        this.cdata1.spouse_age = this.formrecruit.get("spouse_age").value;
      if (this.cdata1.occupation != this.formrecruit.get("occupation").value)
        this.cdata1.occupation = this.formrecruit.get("occupation").value;
      if (this.cdata1.spouse_occupation != this.formrecruit.get("spouse_occupation").value)
        this.cdata1.spouse_occupation = this.formrecruit.get("spouse_occupation").value;
      if (this.cdata1.height != this.formrecruit.get("height").value)
        this.cdata1.height = this.formrecruit.get("height").value;
      if (this.cdata1.spouse_height != this.formrecruit.get("spouse_height").value)
        this.cdata1.spouse_height = this.formrecruit.get("spouse_height").value;
      if (this.cdata1.weight != this.formrecruit.get("weight").value)
        this.cdata1.weight = this.formrecruit.get("weight").value;
      if (this.cdata1.spouse_weight != this.formrecruit.get("spouse_weight").value)
        this.cdata1.spouse_weight = this.formrecruit.get("spouse_weight").value;
      if (this.cdata1.smoker != this.formrecruit.get("smoker").value)
        this.cdata1.smoker = this.formrecruit.get("smoker").value;
      if (this.cdata1.spouse_smoker != this.formrecruit.get("spouse_smoker").value)
        this.cdata1.spouse_smoker = this.formrecruit.get("spouse_smoker").value;
      if (this.cdata1.health_issue != this.formrecruit.get("health_issue").value)
        this.cdata1.health_issue = this.formrecruit.get("health_issue").value;
      if (this.cdata1.spouse_health_issue != this.formrecruit.get("spouse_health_issue").value)
        this.cdata1.spouse_health_issue = this.formrecruit.get("spouse_health_issue").value;
      if (this.cdata1.lender != this.formrecruit.get("lender").value)
        this.cdata1.lender = this.formrecruit.get("lender").value;
      if (this.cdata1.beneficiary != this.formrecruit.get("beneficiary").value)
        this.cdata1.beneficiary = this.formrecruit.get("beneficiary").value;
      if (this.cdata1.mortgage_amount != this.formrecruit.get("mortgage_amount").value)
        this.cdata1.mortgage_amount = this.formrecruit.get("mortgage_amount").value;
      if (this.cdata1.lead_level != this.formrecruit.get("lead_level").value)
        this.cdata1.lead_level = this.formrecruit.get("lead_level").value;
      if (this.cdata1.purchase_refi != this.formrecruit.get("purchase_refi").value)
        this.cdata1.purchase_refi = this.formrecruit.get("purchase_refi").value;
           if (this.cdata1.home_value != this.formrecruit.get("home_value").value)
        this.cdata1.home_value = this.formrecruit.get("home_value").value;
      if (this.cdata1.status != this.formrecruit.get("status").value)
        this.cdata1.status = this.formrecruit.get("status").value;
      if (this.cdata1.mortgage_term != this.formrecruit.get("mortgage_term").value)
        this.cdata1.mortgage_term = this.formrecruit.get("mortgage_term").value;
      if (this.cdata1.referrer != this.formrecruit.get("referrer").value)
        this.cdata1.referrer = this.formrecruit.get("referrer").value;
      if (this.cdata1.monthly_mortage_payment != this.formrecruit.get("monthly_mortage_payment").value)
        this.cdata1.monthly_mortage_payment = this.formrecruit.get("monthly_mortage_payment").value;
      if (this.cdata1.reason != this.formrecruit.get("reason").value)
        this.cdata1.reason = this.formrecruit.get("reason").value;
      if (this.cdata1.field_1 != this.formrecruit.get("field_1").value)
        this.cdata1.field_1 = this.formrecruit.get("field_1").value;
      if (this.cdata1.field_2 != this.formrecruit.get("field_2").value)
        this.cdata1.field_2 = this.formrecruit.get("field_2").value;
      if (this.cdata1.field_3 != this.formrecruit.get("field_3").value)
        this.cdata1.field_3 = this.formrecruit.get("field_3").value;
      if (this.cdata1.field_4 != this.formrecruit.get("field_4").value)
        this.cdata1.field_4 = this.formrecruit.get("field_4").value;
      if (this.cdata1.field_5 != this.formrecruit.get("field_5").value)
        this.cdata1.field_5 = this.formrecruit.get("field_5").value;
      if (this.cdata1.field_6 != this.formrecruit.get("field_6").value)
        this.cdata1.field_6 = this.formrecruit.get("field_6").value;
      if (this.cdata1.field_7 != this.formrecruit.get("field_7").value)
        this.cdata1.field_7 = this.formrecruit.get("field_7").value;
      if (this.cdata1.field_8 != this.formrecruit.get("field_8").value)
        this.cdata1.field_8 = this.formrecruit.get("field_8").value;
      if (this.cdata1.field_9 != this.formrecruit.get("field_9").value)
        this.cdata1.field_9 = this.formrecruit.get("field_9").value;
      if (this.cdata1.field_10 != this.formrecruit.get("field_10").value)
        this.cdata1.field_10 = this.formrecruit.get("field_10").value;
      if (this.cdata1.field_11 != this.formrecruit.get("field_11").value)
        this.cdata1.field_11 = this.formrecruit.get("field_11").value;
      if (this.cdata1.field_12 != this.formrecruit.get("field_12").value)
        this.cdata1.field_12 = this.formrecruit.get("field_12").value;
      if (this.cdata1.field_13 != this.formrecruit.get("field_13").value)
        this.cdata1.field_13 = this.formrecruit.get("field_13").value;
      if (this.cdata1.field_14 != this.formrecruit.get("field_14").value)
        this.cdata1.field_14 = this.formrecruit.get("field_14").value;
      if (this.cdata1.field_15 != this.formrecruit.get("field_15").value)
        this.cdata1.field_15 = this.formrecruit.get("field_15").value;
      if (this.cdata1.field_16 != this.formrecruit.get("field_16").value)
        this.cdata1.field_16 = this.formrecruit.get("field_16").value;
      if (this.cdata1.field_17 != this.formrecruit.get("field_17").value)
        this.cdata1.field_17 = this.formrecruit.get("field_17").value;
      if (this.cdata1.field_18 != this.formrecruit.get("field_18").value)
        this.cdata1.field_18 = this.formrecruit.get("field_18").value;
      if (this.cdata1.field_19 != this.formrecruit.get("field_19").value)
        this.cdata1.field_19 = this.formrecruit.get("field_19").value;
      if (this.cdata1.field_20 != this.formrecruit.get("field_20").value)
        this.cdata1.field_20 = this.formrecruit.get("field_20").value;
      if (this.cdata1.field_21 != this.formrecruit.get("field_21").value)
        this.cdata1.field_21 = this.formrecruit.get("field_21").value;
      if (this.cdata1.field_22 != this.formrecruit.get("field_22").value)
        this.cdata1.field_22 = this.formrecruit.get("field_22").value;
      if (this.cdata1.field_23 != this.formrecruit.get("field_23").value)
        this.cdata1.field_23 = this.formrecruit.get("field_23").value;
      if (this.cdata1.field_24 != this.formrecruit.get("field_24").value)
        this.cdata1.field_24 = this.formrecruit.get("field_24").value;
      if (this.cdata1.field_15 != this.formrecruit.get("field_15").value)
        this.cdata1.field_15 = this.formrecruit.get("field_15").value;
      if (this.cdata1.field_26 != this.formrecruit.get("field_26").value)
        this.cdata1.field_26 = this.formrecruit.get("field_26").value;
      if (this.cdata1.field_27 != this.formrecruit.get("field_27").value)
        this.cdata1.field_27 = this.formrecruit.get("field_27").value;
      if (this.cdata1.field_28 != this.formrecruit.get("field_28").value)
        this.cdata1.field_28 = this.formrecruit.get("field_28").value;
      if (this.cdata1.field_29 != this.formrecruit.get("field_29").value)
        this.cdata1.field_29 = this.formrecruit.get("field_29").value;
      if (this.cdata1.field_30 != this.formrecruit.get("field_30").value)
        this.cdata1.field_30 = this.formrecruit.get("field_30").value;
      if (this.cdata1.field_31 != this.formrecruit.get("field_31").value)
        this.cdata1.field_31 = this.formrecruit.get("field_31").value;
      if (this.cdata1.field_32 != this.formrecruit.get("field_32").value)
        this.cdata1.field_32 = this.formrecruit.get("field_32").value;
      if (this.cdata1.field_33 != this.formrecruit.get("field_33").value)
        this.cdata1.field_33 = this.formrecruit.get("field_33").value;
      if (this.cdata1.field_34 != this.formrecruit.get("field_34").value)
        this.cdata1.field_34 = this.formrecruit.get("field_34").value;
      if (this.cdata1.field_35 != this.formrecruit.get("field_35").value)
        this.cdata1.field_35 = this.formrecruit.get("field_35").value;
      if (this.cdata1.field_36 != this.formrecruit.get("field_36").value)
        this.cdata1.field_36 = this.formrecruit.get("field_36").value;
      if (this.cdata1.field_37 != this.formrecruit.get("field_37").value)
        this.cdata1.field_37 = this.formrecruit.get("field_37").value;
      if (this.cdata1.field_38 != this.formrecruit.get("field_38").value)
        this.cdata1.field_38 = this.formrecruit.get("field_38").value;
      if (this.cdata1.field_39 != this.formrecruit.get("field_39").value)
        this.cdata1.field_39 = this.formrecruit.get("field_39").value;
      if (this.cdata1.field_40 != this.formrecruit.get("field_40").value)
        this.cdata1.field_40 = this.formrecruit.get("field_40").value;
      if (this.cdata1.field_41 != this.formrecruit.get("field_41").value)
        this.cdata1.field_41 = this.formrecruit.get("field_41").value;
      if (this.cdata1.field_42 != this.formrecruit.get("field_42").value)
        this.cdata1.field_42 = this.formrecruit.get("field_42").value;
      if (this.cdata1.field_43 != this.formrecruit.get("field_43").value)
        this.cdata1.field_43 = this.formrecruit.get("field_43").value;
      if (this.cdata1.field_44 != this.formrecruit.get("field_44").value)
        this.cdata1.field_44 = this.formrecruit.get("field_44").value;
      if (this.cdata1.field_45 != this.formrecruit.get("field_45").value)
        this.cdata1.field_45 = this.formrecruit.get("field_45").value;
      if (this.cdata1.field_46 != this.formrecruit.get("field_46").value)
        this.cdata1.field_46 = this.formrecruit.get("field_46").value;
      if (this.cdata1.field_47 != this.formrecruit.get("field_47").value)
        this.cdata1.field_47 = this.formrecruit.get("field_47").value;
      if (this.cdata1.field_48 != this.formrecruit.get("field_48").value)
        this.cdata1.field_48 = this.formrecruit.get("field_48").value;
      if (this.cdata1.field_49 != this.formrecruit.get("field_49").value)
        this.cdata1.field_49 = this.formrecruit.get("field_49").value;
      if (this.cdata1.field_50 != this.formrecruit.get("field_50").value)
        this.cdata1.field_50 = this.formrecruit.get("field_50").value;
      if (this.cdata1 != this.formrecruit.get("job").value)
        this.cdata1.job = this.formrecruit.get("job").value;
      if (this.cdata1 != this.formrecruit.get("exp").value)
        this.cdata1.exp = this.formrecruit.get("exp").value;
      if (this.cdata1 != this.formrecruit.get("notes").value)
        this.cdata1.notes = this.formrecruit.get("notes").value
      if (this.cdata1 != this.formrecruit.get("rating").value)
        this.cdata1.rating = this.formrecruit.get("rating").value;
      if (this.cdata1 != this.formrecruit.get("star_rating").value)
        this.cdata1.star_rating = this.formrecruit.get("star_rating").value;
      if (this.cdata1 != this.formrecruit.get("labels").value)
        this.cdata1.labels = this.formrecruit.get("labels").value;
      if (this.cdata1 != this.formrecruit.get("candidate_overview").value)
        this.cdata1.candidate_overview = this.formrecruit.get("candidate_overview").value;
      if (this.cdata1 != this.formrecruit.get("ques_ans").value)
        this.cdata1.ques_ans = this.formrecruit.get("ques_ans").value;
      if (this.cdata1 != this.formrecruit.get("disposition").value)
        this.cdata1.disposition = this.formrecruit.get("disposition").value;
      if (this.cdata1 != this.formrecruit.get("resume").value)
        this.cdata1.resume = this.formrecruit.get("resume").value;
      if (this.cdata1 != this.formrecruit.get("dealbreakerquescorrect").value)
        this.cdata1.dealbreakerquescorrect = this.formrecruit.get("dealbreakerquescorrect").value
      if (this.cdata1 != this.formrecruit.get("duration").value)
        this.cdata1.duration = this.formrecruit.get("duration").value;
      if (this.cdata1 != this.formrecruit.get("recent_comp").value)
        this.cdata1.recent_comp = this.formrecruit.get("recent_comp").value;
      if (this.cdata1 != this.formrecruit.get("recent_post").value)
        this.cdata1.recent_post = this.formrecruit.get("recent_post").value;
      if (this.cdata1 != this.formrecruit.get("recent_pay").value)
        this.cdata1.recent_pay = this.formrecruit.get("recent_pay").value;
      if (this.cdata1 != this.formrecruit.get("school").value)
        this.cdata1.school = this.formrecruit.get("school").value;
      if (this.cdata1 != this.formrecruit.get("major").value)
        this.cdata1.major = this.formrecruit.get("major").value;
      if (this.cdata1 != this.formrecruit.get("degree").value)
        this.cdata1.degree = this.formrecruit.get("degree").value;
    }

    if (this.cdata.cell_phone != this.form.get("cell_phone").value) {
      let cellnum = this.form.get("cell_phone").value;
      if (cellnum) {
        var numberPattern = /\d+/g;
        let cellno = (cellnum).match(numberPattern);
        cellnum = '';
        cellno.forEach(val => {
          cellnum += val;
        })
        // if (cellnum.length == 10)
          // cellnum = '1' + cellnum;
      }
      this.cdata.cell_phone = cellnum;
    }
    if (this.cdata.phone != this.form.get("phone").value) {
      let homenum = this.form.get("phone").value;
      if (homenum) {
        var numberPattern = /\d+/g;
        let homeno = (homenum).match(numberPattern);
        homenum = '';
        homeno.forEach(val => {
          homenum += val;
        })
        // if (homenum.length == 10)
        //   homenum = '1' + homenum;
      }
      this.cdata.phone = homenum;
    }
    if (this.cdata.work_phone != this.form.get("work_phone").value) {
      let worknum = this.form.get("work_phone").value;
      if (worknum) {
        var numberPattern = /\d+/g;
        let workno = (worknum).match(numberPattern);
        worknum = '';
        workno.forEach(val => {
          worknum += val;
        })
        // if (worknum.length == 10)
        //   worknum = '1' + worknum;
      }
      this.cdata.work_phone = worknum;
    }

    if (this.cdata.cell_phone && this.cdata.cell_phone != "")
      this.cellnostatus.next(true);
    else
      this.cellnostatus.next(false);

    if (this.cdata.phone && this.cdata.phone != "")
      this.homenostatus.next(true);
    else
      this.homenostatus.next(false);

    if (this.cdata.work_phone && this.cdata.work_phone != "")
      this.worknostatus.next(true);
    else
      this.worknostatus.next(false);

    if (this.cdata.email && this.cdata.email != "")
      this.emailstatus.next(true);
    else
      this.emailstatus.next(false);
  }

  changeEvnt(key: string) {

    console.log(key);
    this.leadtimezone = this.cdata.timezone = this.form.get("timezone").value;
    console.log(this.leadtimezone)
    if (key == 'first_name')
      this.cdata.first_name = this.form.get("first_name").value;
    if (key == 'last_name')
      this.cdata.last_name = this.form.get("last_name").value;
    if (key == 'spouse_full_name')
      this.cdata.spouse_full_name = this.form.get("spouse_full_name").value;
    if (key == 'street_address_1')
      this.cdata.street_address_1 = this.form.get("street_address_1").value;
    if (key == 'city')
      this.cdata.city = this.form.get("city").value;
    if (key == 'state')
      this.cdata.state = this.form.get("state").value;
    if (key == 'zip')
      this.cdata.zip = this.form.get("zip").value;
    if (key == 'county')
      this.cdata.county = this.form.get("county").value;
    if (key == 'email')
      this.cdata.email = this.form.get("email").value;
    if (key == 'timezone')
      this.cdata.timezone = this.form.get("timezone").value;

 
      this.cdata.fullname = this.form.get("first_name").value.toUpperCase()+" " +this.form.get("last_name").value.toUpperCase()

    /* Recruitign personal data */

    if (this.currcampflag == '1') {
      console.log("inside curr");
      
      if (key == 'lead_source')
      this.cdata.lead_source = this.form.get("lead_source").value;
      
      
      if(key="assign_date")
       this.cdata1.assign_date=this.form.get("assign_date").value;
      if (key == 'birth_date')
        this.cdata1.birth_date = this.formrecruit.get("birth_date").value;
      if (key == 'spouse_birth_date')
        this.cdata1.spouse_birth_date = this.formrecruit.get("spouse_birth_date").value;
      if (key == 'age')
        this.cdata1.age = this.formrecruit.get("age").value;
      if (key == 'spouse_age')
        this.cdata1.spouse_age = this.formrecruit.get("spouse_age").value;
      if (key == 'occupation')
        this.cdata1.occupation = this.formrecruit.get("occupation").value;
      if (key == 'spouse_occupation')
        this.cdata1.spouse_occupation = this.formrecruit.get("spouse_occupation").value;
      if (key == 'height')
        this.cdata1.height = this.formrecruit.get("height").value;
      if (key == 'spouse_height')
        this.cdata1.spouse_height = this.formrecruit.get("spouse_height").value;
      if (key == 'weight')
        this.cdata1.weight = this.formrecruit.get("weight").value;
      if (key == 'spouse_weight')
        this.cdata1.spouse_weight = this.formrecruit.get("spouse_weight").value;
      if (key == 'smoker')
        this.cdata1.smoker = this.formrecruit.get("smoker").value;
      if (key == 'spouse_smoker')
        this.cdata1.spouse_smoker = this.formrecruit.get("spouse_smoker").value;
      if (key == 'health_issue')
        this.cdata1.health_issue = this.formrecruit.get("health_issue").value;
      if (key == 'spouse_health_issue')
        this.cdata1.spouse_health_issue = this.formrecruit.get("spouse_health_issue").value;
      if (key == 'lender')
        this.cdata1.lender = this.formrecruit.get("lender").value;
      if (key == 'beneficiary')
        this.cdata1.beneficiary = this.formrecruit.get("beneficiary").value;
      if (key == 'mortgage_amount')
        this.cdata1.mortgage_amount = this.formrecruit.get("mortgage_amount").value;
      if (key == 'lead_level')
        this.cdata1.lead_level = this.formrecruit.get("lead_level").value;
      if (key == 'purchase_refi')
        this.cdata1.purchase_refi = this.formrecruit.get("purchase_refi").value;
      // if (key == 'assign_date')
      //   this.cdata1.assign_date = this.formrecruit.get("assign_date").value;
      if (key == 'home_value')
        this.cdata1.home_value = this.formrecruit.get("home_value").value;
      if (key == 'status')
        this.cdata1.status = this.formrecruit.get("status").value;
      if (key == 'mortgage_term')
        this.cdata1.mortgage_term = this.formrecruit.get("mortgage_term").value;
      if (key == 'referrer')
        this.cdata1.referrer = this.formrecruit.get("referrer").value;
      if (key == 'monthly_mortage_payment')
        this.cdata1.monthly_mortage_payment = this.formrecruit.get("monthly_mortage_payment").value;
      if (key == 'reason')
        this.cdata1.reason = this.formrecruit.get("reason").value;
      if (key == 'field_1')
        this.cdata1.field_1 = this.formrecruit.get("field_1").value;
      if (key == 'field_2')
        this.cdata1.field_2 = this.formrecruit.get("field_2").value;
      if (key == 'field_3')
        this.cdata1.field_3 = this.formrecruit.get("field_3").value;
      if (key == 'field_4')
        this.cdata1.field_4 = this.formrecruit.get("field_4").value;
      if (key == 'field_5')
        this.cdata1.field_5 = this.formrecruit.get("field_5").value;
      if (key == 'field_6')
        this.cdata1.field_6 = this.formrecruit.get("field_6").value;
      if (key == 'field_7')
        this.cdata1.field_7 = this.formrecruit.get("field_7").value;
      if (key == 'field_8')
        this.cdata1.field_8 = this.formrecruit.get("field_8").value;
      if (key == 'field_9')
        this.cdata1.field_9 = this.formrecruit.get("field_9").value;
      if (key == 'field_10')
        this.cdata1.field_10 = this.formrecruit.get("field_10").value;
      if (key == 'field_11')
        this.cdata1.field_11 = this.formrecruit.get("field_11").value;
      if (key == 'field_12')
        this.cdata1.field_12 = this.formrecruit.get("field_12").value;
      if (key == 'field_13')
        this.cdata1.field_13 = this.formrecruit.get("field_13").value;
      if (key == 'field_14')
        this.cdata1.field_14 = this.formrecruit.get("field_14").value;
      if (key == 'field_15')
        this.cdata1.field_15 = this.formrecruit.get("field_15").value;
      if (key == 'field_16')
        this.cdata1.field_16 = this.formrecruit.get("field_16").value;
      if (key == 'field_17')
        this.cdata1.field_17 = this.formrecruit.get("field_17").value;
      if (key == 'field_18')
        this.cdata1.field_18 = this.formrecruit.get("field_18").value;
      if (key == 'field_19')
        this.cdata1.field_19 = this.formrecruit.get("field_19").value;
      if (key == 'field_20')
        this.cdata1.field_20 = this.formrecruit.get("field_20").value;
      if (key == 'field_21')
        this.cdata1.field_21 = this.formrecruit.get("field_21").value;
      if (key == 'field_22')
        this.cdata1.field_22 = this.formrecruit.get("field_22").value;
      if (key == 'field_23')
        this.cdata1.field_23 = this.formrecruit.get("field_23").value;
      if (key == 'field_24')
        this.cdata1.field_24 = this.formrecruit.get("field_24").value;
      if (key == 'field_25')
        this.cdata1.field_25 = this.formrecruit.get("field_25").value;
      if (key == 'field_26')
        this.cdata1.field_26 = this.formrecruit.get("field_26").value;
      if (key == 'field_27')
        this.cdata1.field_27 = this.formrecruit.get("field_27").value;
      if (key == 'field_28')
        this.cdata1.field_28 = this.formrecruit.get("field_28").value;
      if (key == 'field_29')
        this.cdata1.field_29 = this.formrecruit.get("field_29").value;
      if (key == 'field_30')
        this.cdata1.field_30 = this.formrecruit.get("field_30").value;
      if (key == 'field_31')
        this.cdata1.field_31 = this.formrecruit.get("field_31").value;
      if (key == 'field_32')
        this.cdata1.field_32 = this.formrecruit.get("field_32").value;
      if (key == 'field_33')
        this.cdata1.field_33 = this.formrecruit.get("field_33").value;
      if (key == 'field_34')
        this.cdata1.field_34 = this.formrecruit.get("field_34").value;
      if (key == 'field_35')
        this.cdata1.field_35 = this.formrecruit.get("field_35").value;
      if (key == 'field_36')
        this.cdata1.field_36 = this.formrecruit.get("field_36").value;
      if (key == 'field_37')
        this.cdata1.field_37 = this.formrecruit.get("field_37").value;
      if (key == 'field_38')
        this.cdata1.field_38 = this.formrecruit.get("field_38").value;
      if (key == 'field_39')
        this.cdata1.field_39 = this.formrecruit.get("field_39").value;
      if (key == 'field_40')
        this.cdata1.field_40 = this.formrecruit.get("field_40").value;
      if (key == 'field_40')
        this.cdata1.field_40 = this.formrecruit.get("field_40").value;
      if (key == 'field_42')
        this.cdata1.field_42 = this.formrecruit.get("field_42").value;
      if (key == 'field_43')
        this.cdata1.field_43 = this.formrecruit.get("field_43").value;
      if (key == 'field_44')
        this.cdata1.field_44 = this.formrecruit.get("field_44").value;
      if (key == 'field_45')
        this.cdata1.field_45 = this.formrecruit.get("field_45").value;
      if (key == 'field_46')
        this.cdata1.field_46 = this.formrecruit.get("field_46").value;
      if (key == 'field_47')
        this.cdata1.field_47 = this.formrecruit.get("field_47").value;
      if (key == 'field_48')
        this.cdata1.field_48 = this.formrecruit.get("field_48").value;
      if (key == 'field_49')
        this.cdata1.field_49 = this.formrecruit.get("field_49").value;
      if (key == 'field_50')
        this.cdata1.field_50 = this.formrecruit.get("field_50").value;
      if (key == 'job')
        this.cdata1.job = this.formrecruit.get("job").value;
      if (key == 'exp')
        this.cdata1.exp = this.formrecruit.get("exp").value;
      if (key == 'notes')
        this.cdata1.notes = this.formrecruit.get("notes").value
      if (key == 'rating')
        this.cdata1.rating = this.formrecruit.get("rating").value;
      if (key == 'star_rating')
        this.cdata1.star_rating = this.formrecruit.get("star_rating").value;
      if (key == 'labels')
        this.cdata1.labels = this.formrecruit.get("labels").value;
      if (key == 'candidate_overview')
        this.cdata1.candidate_overview = this.formrecruit.get("candidate_overview").value;
      if (key == 'ques_ans')
        this.cdata1.ques_ans = this.formrecruit.get("ques_ans").value;
      if (key == 'disposition')
        this.cdata1.disposition = this.formrecruit.get("disposition").value;
      if (key == 'resume')
        this.cdata1.resume = this.formrecruit.get("resume").value;
      if (key == 'dealbreakerquescorrect')
        this.cdata1.dealbreakerquescorrect = this.formrecruit.get("dealbreakerquescorrect").value
      if (key == 'duration')
        this.cdata1.duration = this.formrecruit.get("duration").value;
      if (key == 'recent_comp')
        this.cdata1.recent_comp = this.formrecruit.get("recent_comp").value;
      if (key == 'recent_post')
        this.cdata1.recent_post = this.formrecruit.get("recent_post").value;
      if (key == 'recent_pay')
        this.cdata1.recent_pay = this.formrecruit.get("recent_pay").value;
      if (key == 'school')
        this.cdata1.school = this.formrecruit.get("school").value;
      if (key == 'major')
        this.cdata1.major = this.formrecruit.get("major").value;
      if (key == 'degree')
        this.cdata1.degree = this.formrecruit.get("degree").value;
    }
    /* recruiting personal data end */
    if (key == 'cell_phone') {
      let cellnum = this.form.get("cell_phone").value;
      console.log("Current Cell Phone ::" + cellnum);
      if (cellnum) {
        var numberPattern = /\d+/g;
        let cellno = (cellnum).match(numberPattern);
        cellnum = '';
        cellno.forEach(val => {
          cellnum += val;
        })
        // if (cellnum.length == 10)
        //   cellnum = '1' + cellnum;
      }
      this.cdata.cell_phone = cellnum;
    }
    if (key == 'phone') {
      let homenum = this.form.get("phone").value;
      if (homenum) {
        var numberPattern = /\d+/g;
        let homeno = (homenum).match(numberPattern);
        homenum = '';
        homeno.forEach(val => {
          homenum += val;
        })
        if (homenum.length == 10)
          homenum = '1' + homenum;
      }
      this.cdata.phone = homenum;
    }
    if (key == 'work_phone') {
      let worknum = this.form.get("work_phone").value;
      if (worknum) {
        var numberPattern = /\d+/g;
        let workno = (worknum).match(numberPattern);
        worknum = '';
        workno.forEach(val => {
          worknum += val;
        })
        if (worknum.length == 10)
          worknum = '1' + worknum;
      }
      this.cdata.work_phone = worknum;
    }

    if (this.cdata.cell_phone && this.cdata.cell_phone != "")
      this.cellnostatus.next(true);
    else
      this.cellnostatus.next(false);

    if (this.cdata.phone && this.cdata.phone != "")
      this.homenostatus.next(true);
    else
      this.homenostatus.next(false);

    if (this.cdata.work_phone && this.cdata.work_phone != "")
      this.worknostatus.next(true);
    else
      this.worknostatus.next(false);
  console.log("this.cdata:::",this.cdata)
    sessionStorage.setItem("edit", JSON.stringify(this.cdata));
    if (this.currcampflag == '1') {
      sessionStorage.setItem("personaldata", JSON.stringify(this.cdata1));
    }

    // console.log("OnChange events called edit data : Key "+key+" Value :"+this.form.get(key).value);
    console.log(sessionStorage.getItem("edit"));
    console.log(sessionStorage.getItem("personaldata"));

    this.theme.Getautosavedata(sessionStorage.getItem("edit"))
  }

  ViewPDF(pdfurl: string) {
    const dialogRef = this.dialog.open(PdfviewerComponent, {
      width: 'auto',
      data: pdfurl
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  getOffset() {
    let currleadtimezone = this.leadtimezone;
    
    let tzoffset = this.timezonelist.find(function (element: any) {
      console.log(element.abbr + "====" + currleadtimezone);
      return element.abbr == currleadtimezone;
    });
    console.log(tzoffset)
    if (tzoffset == undefined)
      return undefined  
    else
      return tzoffset.offset;
  }

  /*  GetTimezone()
   {
     let count:number=0;
     this.timezone.forEach((ele:any)=>{
       console.log("TIme Zone Row", ele);
       console.log(ele.zip+"=="+this.cdata.zip);
       console.log("Count ::"+count);
       if(count==0)
       {
         if(ele.zip==this.cdata.zip)
         {
           this.ct_timezone=ele.timezone;
           count++;
         }
         else
         {
           if(ele.city==this.cdata.city)
           {
             this.ct_timezone=ele.timezone;
             count++;
           }
           else
           {
             if(ele.county==this.cdata.county)
             {
               this.ct_timezone=ele.timezone;
               count++;
             }
             else
             {
               if(ele.state==this.cdata.state)
               {
                 this.ct_timezone=ele.timezone;
                 count++;
               }
               else
               {
                 if(this.cdata.cell_phone != null && this.cdata.cell_phone != undefined && this.cdata.cell_phone != "null" && this.cdata.cell_phone != "")
                 {
                   let areacode = this.cdata.cell_phone.substr(1,3);
                   if(ele.account==areacode)
                   {
                     this.ct_timezone=ele.timezone;
                     count++;
                   }
                   else
                     this.ct_timezone="EST";
                 }
                 else
                 {
                   if(this.cdata.phone != null && this.cdata.phone != undefined && this.cdata.phone != "null" && this.cdata.phone != "")
                   {
                     let areacode = this.cdata.phone.substr(1,3);
                     if(ele.account==areacode)
                     {
                       this.ct_timezone=ele.timezone;
                       count++;
                     }
                     else
                       this.ct_timezone="EST";
                   }
                   else
                   {
                     if(this.cdata.work_phone != null && this.cdata.work_phone != undefined && this.cdata.work_phone != "null" && this.cdata.work_phone != "")
                     {
                       let areacode = this.cdata.work_phone.substr(1,3);
                       if(ele.account==areacode)
                       {
                         this.ct_timezone=ele.timezone;
                         count++;
                       }
                       else
                         this.ct_timezone="EST";
                     }
                     else
                     {
                       this.ct_timezone="EST";
                     }
                   }
                 }
               }
             }
           }
         }
       }
     });
   } */

  ngOnDestroy(): void {
    console.log("NG Destroye Called");
    this.autodsubs.unsubscribe();
    this.autostopdsubs.unsubscribe();
    this.eventsubs.unsubscribe();
    this.callersubs.unsubscribe();
    this.personalnosubs.unsubscribe();
    this.senddtmfsipsubs.unsubscribe();
  }

  setCurrentTime(){
    let agent_currtime = sessionStorage.getItem('timezone')
    let tzoffset = this.timezonelist.find(function (element: any) {
      return element.abbr == agent_currtime; });
    var d = new Date();
    let GMT =`GMT ${tzoffset.diff}`
   let currtime=  this.datepipe.transform(d, "MM/dd/yyyy h:mm a",GMT);
           this.cdata.current_time =currtime
    console.log(this.cdata);
    sessionStorage.setItem("edit", JSON.stringify(this.cdata));
    }
    time_transform(time: any): any {
      let hour = (time.split(':'))[0]
      let min = (time.split(':'))[1]
      let part = hour > 12 ? 'pm' : 'am';
      if(parseInt(hour) == 0)
       hour = 12;
      min = (min+'').length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour+'').length == 1 ? `0${hour}` : hour;
      return `${hour}:${min} ${part}`
    }
}

